if (!customElements.get('tr-fake-pagination')) {
	class TrFakePagination extends HTMLElement {
		selectors = {
			button: '[data-tr-js-fake-pagination-button]',
			item: '[data-tr-js-fake-pagination-item]',
		};

		attributes = {
			delayMs: 'data-tr-fake-pagination-delay-ms',
			target: 'data-tr-fake-pagination-target',
			visibleCount: 'data-tr-fake-pagination-visible-count',
			stepCount: 'data-tr-fake-pagination-step-count',
		};

		stateClasses = {
			isHidden: 'is-hidden',
			isDisabled: 'is-disabled',
			isLoading: 'is-loading',
		};

		connectedCallback() {
			this.buttonElement = this.querySelector(this.selectors.button);
			this.init();
			this.bindEvents();
			document.addEventListener('shopify:section:load', this.onSectionLoad);
		}

		disconnectedCallback() {
			document.removeEventListener('shopify:section:load', this.onSectionLoad);
			this.destroy();
		}

		init() {
			this.targetSelector = this.getAttribute(this.attributes.target) || '';
			this.visibleCount =
				Number(this.getAttribute(this.attributes.visibleCount)) || 0;
			this.stepCount = Number(this.getAttribute(this.attributes.stepCount)) || 0;
			this.delayMs = Number(this.getAttribute(this.attributes.delayMs)) || 0;
			this.isLoading = false;
			this.itemElements = this.getItemElements();

			this.updateItems();
			this.updateButton();
		}

		bindEvents() {
			this.buttonElement?.removeEventListener('click', this.onButtonClick);
			this.buttonElement?.addEventListener('click', this.onButtonClick);
		}

		onSectionLoad = (event) => {
			const sectionId = event.detail.sectionId;

			if (
				!this.closest(`#shopify-section-${sectionId}`) &&
				!this.closest(`#${sectionId}`)
			) {
				return;
			}

			this.destroy();
			this.buttonElement = this.querySelector(this.selectors.button);
			this.init();
			this.bindEvents();
		};

		onButtonClick = async () => {
			if (this.isLoading) return;

			this.setLoadingState(true);
			await this.wait(this.delayMs);
			this.visibleCount += this.stepCount;
			this.updateItems();
			this.setLoadingState(false);
			this.updateButton();
		};

		updateItems() {
			this.itemElements.forEach((itemElement, itemIndex) => {
				const shouldHideItem = itemIndex >= this.visibleCount;

				itemElement.classList.toggle(this.stateClasses.isHidden, shouldHideItem);
			});
		}

		updateButton() {
			if (!this.buttonElement) return;

			const hasHiddenItems = this.itemElements.some((itemElement) =>
				itemElement.classList.contains(this.stateClasses.isHidden)
			);

			this.buttonElement.classList.toggle(
				this.stateClasses.isDisabled,
				!hasHiddenItems
			);
			this.buttonElement.hidden = !hasHiddenItems;
			this.buttonElement.setAttribute('aria-disabled', String(!hasHiddenItems));
			this.buttonElement.disabled = !hasHiddenItems;

			if (!hasHiddenItems) {
				this.setAttribute('hidden', '');
				return;
			}

			this.removeAttribute('hidden');
		}

		getItemElements() {
			if (!this.targetSelector) return [];

			const sectionElement = this.closest('section');
			const targetElement =
				sectionElement?.querySelector(this.targetSelector) ||
				this.closest('[id^="shopify-section-"]')?.querySelector(this.targetSelector) ||
				document.querySelector(this.targetSelector);

			if (!targetElement) return [];

			return Array.from(targetElement.querySelectorAll(this.selectors.item));
		}

		setLoadingState(isLoading) {
			this.isLoading = isLoading;
			this.buttonElement?.classList.toggle(this.stateClasses.isLoading, isLoading);
			this.buttonElement?.classList.toggle(this.stateClasses.isDisabled, isLoading);
			this.buttonElement?.setAttribute('aria-busy', String(isLoading));
			this.buttonElement?.setAttribute('aria-disabled', String(isLoading));
			this.buttonElement?.toggleAttribute('disabled', isLoading);
		}

		wait(delayMs) {
			return new Promise((resolve) => {
				window.setTimeout(resolve, delayMs);
			});
		}

		destroy() {
			this.buttonElement?.removeEventListener('click', this.onButtonClick);
			this.setLoadingState(false);
		}
	}

	customElements.define('tr-fake-pagination', TrFakePagination);
}
